import { Pipe, PipeTransform } from '@angular/core';
import { L10nTranslationService } from 'angular-l10n';
import { ReferenceDataService } from 'core/reference-data.service';
import { ModuleDto } from 'shared/service-clients/reference';

@Pipe({ name: 'module' })
export class ModulePipe implements PipeTransform {
  modules: ModuleDto[] = [];

  moduledescription: string;
  constructor(private referenceDataService: ReferenceDataService) {

    this.referenceDataService.getModules().subscribe(x => {
      this.modules = x.result;
    });
  }
  transform(valueId: string): any {

    if (valueId === null || valueId === undefined || valueId === '' || valueId === '00000000-0000-0000-0000-000000000000') {
      return '';
    }

    let module = this.modules.find(x => x.id.toLowerCase() == valueId.toLowerCase())
    if (module) {
      return module.description + ' (' + module.name + ')';
    }
  }
}
